module.exports = __webpack_public_path__ + "static/media/off-btn.fe21bbc9.png";